import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { db } from './firebase';
import './App.scss';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { makeAlert } from './helper';
import { geolocated } from 'react-geolocated';
import DetailsCard from './components/DetailsCard';

function App(props) {
  const [amount, setAmount] = useState('');
  const [purpose, setPurpose] = useState('');
  const [history, setHistory] = useState([]);
  const [sohanL, setSohanL] = useState(0);
  const [rakibL, setRakibL] = useState(0);
  const [working, setWorking] = useState(false);
  const [payer, setPayer] = useState('');
  const [showAddCost, setShowAddCost] = useState(false);
  const [lastTen, setLastTen] = useState([]);

  useEffect(() => {
    const ref = db.ref(`account`);
    ref.on('value', snap => {
      if (snap.val() !== null) {
        setHistory(Object.values(snap.val()));
      }
    });
  }, []);

  useEffect(() => {
    let sohanLiability = 0;
    let rakibLiability = 0;
    setLastTen(history.slice(Math.max(history.length - 5, 0)).reverse());
    history.forEach(h => {
      const { amount, sohanPaid, rakibPaid } = h;
      if (sohanPaid !== rakibPaid) {
        const half = Math.round(amount / 2);
        if (sohanPaid < half) {
          sohanLiability += half - sohanPaid;
        }
        if (rakibPaid < half) {
          rakibLiability += half - rakibPaid;
        }
      }
    });
    setSohanL(sohanLiability);
    setRakibL(rakibLiability);
  }, [history]);

  const _insertData = () => {
    if (amount !== '' && purpose !== '' && payer !== '') {
      const datetime = moment().format('lll');
      const ref = db.ref(`account`);
      setWorking(true);
      const data = {
        amount: parseInt(amount),
        purpose: purpose,
        rakibPaid: payer === 'sohan' ? 0 : parseInt(amount),
        sohanPaid: payer === 'rakib' ? 0 : parseInt(amount),
        datetime
      };
      if (props.isGeolocationAvailable) {
        const { latitude, longitude, altitude, heading } = props.coords;
        data.location = {
          latitude,
          longitude,
          altitude,
          heading
        };
      }
      ref
        .push(data)
        .then(() => {
          setAmount('');
          setPurpose('');
          setPayer('');
          setWorking(false);
          setShowAddCost(false);
          makeAlert('success', 'Added successfully');
        })
        .catch(() => {
          makeAlert('danger', 'উহু! কিছু সমস্যা হয়েছে!');
          setWorking(false);
        });
    }
  };

  const handleChange = name => e => {
    if (name === 'amount') {
      setAmount(e.target.value);
    }
    if (name === 'purpose') {
      setPurpose(e.target.value);
    }
    if (name === 'amoundSlider') {
      console.log(e.target);
    }
    if (name === 'payer') {
      setPayer(e.target.value);
    }
  };

  return (
    <div className='container'>
      <ReactNotification />
      <div
        className='fav'
        onClick={() => {
          setShowAddCost(true);
          setTimeout(() => {
            document.getElementById('amount-input').focus();
          }, 100);
        }}
      >
        New Cost
      </div>
      <section className='top-card'>
        <div className='single'>
          <p className='name'>Rakib owes</p>
          <p className='amount'>{rakibL}</p>
        </div>
        <div className='single'>
          <p className='name'>Sohan owes</p>
          <p className='amount'>{sohanL}</p>
        </div>
      </section>
      <section className='last'>
        <h1 className='title'>Last 5 transactions</h1>
        {lastTen.map((history, idx) => (
          <DetailsCard key={idx} history={history} />
        ))}
      </section>
      {showAddCost && (
        <section className='new-cost'>
          <div className='close-new'>
            <i
              onClick={() => {
                setShowAddCost(false);
              }}
              style={{ cursor: 'pointer' }}
              className='material-icons'
            >
              close
            </i>
            <h2 className='title'>New Cost</h2>
          </div>
          <div>
            <div className='a-p'>
              <div className='group'>
                <input
                  type='number'
                  id='amount-input'
                  required='required'
                  value={amount}
                  disabled={working}
                  onChange={handleChange('amount')}
                />
                <span className='highlight'></span>
                <span className='bar'></span>
                <label>Amount</label>
              </div>
              <div className='group'>
                <input
                  type='text'
                  required='required'
                  value={purpose}
                  disabled={working}
                  onChange={handleChange('purpose')}
                />
                <span className='highlight'></span>
                <span className='bar'></span>
                <label>Purpose</label>
              </div>
            </div>
            <div className='payer' onChange={handleChange('payer')}>
              <p
                style={{
                  fontSize: '14px',
                  marginBottom: '16px',
                  fontWeight: 800,
                  color: '#05f'
                }}
              >
                Payer
              </p>
              <div className='icheck-material-zanvent'>
                <input type='radio' id='rakib' value='rakib' name='payer' />
                <label htmlFor='rakib'>Rakib</label>
              </div>
              <div style={{ height: '5px' }}></div>
              <div className='icheck-material-zanvent'>
                <input type='radio' id='sohan' value='sohan' name='payer' />
                <label htmlFor='sohan'>Sohan</label>
              </div>
            </div>
            <div style={{ marginTop: '18px' }}>
              <button
                onClick={_insertData}
                disabled={
                  amount === '' || purpose === '' || payer === '' || working
                }
              >
                Add Cost
              </button>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true
  },
  userDecisionTimeout: 5000
})(App);
